
const myCustomSlider = document.querySelectorAll('.carousel-swiper');
const myCustomPrev = document.querySelectorAll('.carousel-button-prev');
const myCustomNext = document.querySelectorAll('.carousel-button-next');

const recentSlider = document.querySelectorAll('.recent-swiper');
const recentPrev = document.querySelectorAll('.recent-button-prev');
const recentNext = document.querySelectorAll('.recent-button-next');

const testimonialSlider = document.querySelectorAll('.testimonials-swiper');
const testimonialPrev = document.querySelectorAll('.testimonial-button-prev');
const testimonialNext = document.querySelectorAll('.testimonial-button-next');

/*
const gallerySlider = document.querySelectorAll('.gallery-swiper');
const galleryPrev = document.querySelectorAll('.gallery-prev');
const galleryNext = document.querySelectorAll('.gallery-next');

const singleSlider = document.querySelectorAll('.single-swiper');
const singlePrev = document.querySelectorAll('.single-button-prev');
const singleNext = document.querySelectorAll('.single-button-next');

const processSlider = document.querySelectorAll('.process-swiper');
const processPrev = document.querySelectorAll('.process-prev');
const processNext = document.querySelectorAll('.process-next');
const processPagination = document.querySelectorAll('.process-pagination');

const pressSlider = document.querySelectorAll('.press-swiper');
const pressPrev = document.querySelectorAll('.press-button-prev');
const pressNext = document.querySelectorAll('.press-button-next');

const behindSlider = document.querySelectorAll('.behind-swiper');

//const recSlider = document.querySelectorAll('.rec-swiper');
*/

if(myCustomSlider.length) {
  for( i=0; i< myCustomSlider.length; i++ ) {
    
    myCustomSlider[i].classList.add('custom-container-' + i);
    myCustomPrev[i].classList.add('custom-prev-' + i);
    myCustomNext[i].classList.add('custom-next-' + i);

    var slider = new Swiper('.custom-container-' + i, {
      slidesPerView: 1.25,
      spaceBetween: 30,
      loop: true,
      navigation: {
        nextEl: '.custom-next-' + i,
        prevEl: '.custom-prev-'+ i,
      },
      breakpoints: {
        989: {
          slidesPerView: 4,
          navigation: {
            nextEl: '.custom-next-' + i,
            prevEl: '.custom-prev-'+ i,
          },
        },
        750: {
          slidesPerView: 2.5,
          navigation: {
            nextEl: '.custom-next-' + i,
            prevEl: '.custom-prev-'+ i,
          },
        },
        450: {
          slidesPerView: 1.5,
          navigation: {
            nextEl: '.custom-next-' + i,
            prevEl: '.custom-prev-'+ i,
          },
        }
      }
    });
  }
}

if(testimonialSlider.length) {
  for( i=0; i< testimonialSlider.length; i++ ) {
    
    testimonialSlider[i].classList.add('testimonial-container-' + i);
    testimonialPrev[i].classList.add('testimonial-prev-' + i);
    testimonialNext[i].classList.add('testimonial-next-' + i);

    var slider = new Swiper('.testimonial-container-' + i, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.testimonial-next-' + i,
        prevEl: '.testimonial-prev-'+ i,
      }
    });
  }
}

if(recentSlider.length) {
  for( i=0; i< recentSlider.length; i++ ) {
    
    recentSlider[i].classList.add('recent-container-' + i);
    // myCustomPrev[i].classList.add('custom-prev-' + i);
    // myCustomNext[i].classList.add('custom-next-' + i);

    var slider = new Swiper('.recent-container-' + i, {
      slidesPerView: 1.75,
      spaceBetween: 30,
      loop: true,
      breakpoints: {
        750: {
          slidesPerView: 4,
          navigation: {
            nextEl: '.recent-next-' + i,
            prevEl: '.recent-prev-'+ i,
          },
        },
        450: {
          slidesPerView: 2.5,
          navigation: {
            nextEl: '.recent-next-' + i,
            prevEl: '.recent-prev-'+ i,
          },
        }
      }
    });
  }
}

/*
if(gallerySlider.length) {
  for( i=0; i< gallerySlider.length; i++ ) {
    
    gallerySlider[i].classList.add('gallery-container-' + i);
    galleryPrev[i].classList.add('gallery-prev-' + i);
    galleryNext[i].classList.add('gallery-next-' + i);

    var slider = new Swiper('.gallery-container-' + i, {
      slidesPerView: 2.5,
      spaceBetween: 12,
      navigation: {
        nextEl: '.gallery-next-' + i,
        prevEl: '.gallery-prev-'+ i,
      },
      breakpoints: {
        750: {
          slidesPerView: 5,
          spaceBetween: 30,
        }
      }
    });
  }
}

if(pressSlider.length) {
  for( i=0; i< pressSlider.length; i++ ) {
    
    pressSlider[i].classList.add('press-swiper-' + i);

    var slider = new Swiper('.press-swiper-' + i, {
      slidesPerView: 2.5,
      spaceBetween: 60,
      loop: true,
      breakpoints: {
        750: {
          slidesPerView: 6,
          touchRatio: 0,
          spaceBetween: 30,
        },
        450: {
          slidesPerView: 4.5,
          spaceBetween: 30,
        }
      }
    });
  }
}

if(singleSlider.length){
  for( i=0; i< singleSlider.length; i++ ) {
    
    singleSlider[i].classList.add('single-container-' + i);
    singlePrev[i].classList.add('single-prev-' + i);
    singleNext[i].classList.add('single-next-' + i);

    var slider = new Swiper('.single-container-' + i, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.single-next-' + i,
        prevEl: '.single-prev-'+ i,
      }
    });
  }
}

if(processSlider.length) {
  for( i=0; i< processSlider.length; i++ ) {
    
    processSlider[i].classList.add('process-container-' + i);
    processPrev[i].classList.add('process-prev-' + i);
    processNext[i].classList.add('process-next-' + i);
    processPagination[i].classList.add('process-pagination-' + i);

    var slider = new Swiper('.process-container-' + i, {
      slidesPerView: 1.5,
      spaceBetween: 30,
      navigation: {
        nextEl: '.process-next-' + i,
        prevEl: '.process-prev-'+ i,
      }, 
      pagination: {
        el: '.process-pagination-' + i,
        type: 'bullets',
      },
      breakpoints: {
        750: {
          slidesPerView: 2.5,
        }
      },
    });
  }
}

if(behindSlider.length){
  for( i=0; i< behindSlider.length; i++ ) {
    
    behindSlider[i].classList.add('behind-container-' + i);

    var slider = new Swiper('.behind-container-' + i, {
      slidesPerView: 1.5,
      spaceBetween: 30,
      touchRatio: 1,
      breakpoints: {
        450: {
          slidesPerView: 2.5,
          spaceBetween: 30,
          touchRatio: 1,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 30,
          touchRatio: 0,
        },
      },
    });
  }
}
*/